module.exports = __webpack_public_path__ + "33940dea5b3f0f32c8661b1e49e4da79.pdf";